module.exports = __webpack_public_path__ + "img/contributionsOtherOff.0e97b69a.svg";